import { render, staticRenderFns } from "./HisseKarPayiHacziForm.vue?vue&type=template&id=08920b1d&scoped=true"
import script from "./HisseKarPayiHacziForm.vue?vue&type=script&lang=ts"
export * from "./HisseKarPayiHacziForm.vue?vue&type=script&lang=ts"
import style0 from "./HisseKarPayiHacziForm.vue?vue&type=style&index=0&id=08920b1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08920b1d",
  null
  
)

export default component.exports